const linkPrototype = () => ({
  // add prototype methods here
});

export const LinkObject = (id = "", label = "") => {
  let link = Object.create(linkPrototype());
  link.id = id;
  link.label = label;
  return link;
};

export let contact_us = LinkObject("contact-us", "Contact Us");
export let submit_a_property = LinkObject(
  "submit-a-property",
  "Submit a property"
);
export let call_to_action = LinkObject("Call to Action", "Call to Action");
export const LINK_REFERENCES = [submit_a_property, contact_us, call_to_action];
export const SHOW_BACKGROUND_WITHOUT_OPACITY = false;
